exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3gUNe9aK{bottom:50px;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0;background:#000}._2iNw4BAM,._3gUNe9aK{position:fixed;top:0;left:0;right:0}._2iNw4BAM{bottom:0;background-color:#f2f2f2}._1zHZADtm{overflow:hidden!important}._2PeVQcYr{visibility:true;z-index:100}.ttzHFiis{visibility:hidden;z-index:0}._1-wUsP-g{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";opacity:.5}.WFN5EGrS{-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";opacity:0}.g_eC772h{-webkit-transform:translateY(0);transform:translateY(0)}._3BPj7nlm{-webkit-transform:translateY(100%);transform:translateY(100%)}._2g00AJlH{-webkit-transition:-webkit-transform .3s ease-in-out;transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}", ""]);

// exports
exports.locals = {
	"backdrop": "_3gUNe9aK",
	"component": "_2iNw4BAM",
	"disable": "_1zHZADtm",
	"wcag-visible": "_2PeVQcYr",
	"wcag-invisible": "ttzHFiis",
	"backdrop-opacity-visible": "_1-wUsP-g",
	"backdrop-opacity-invisible": "WFN5EGrS",
	"transform0": "g_eC772h",
	"transform1": "_3BPj7nlm",
	"motioncomponent": "_2g00AJlH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/shared/fullscreen/style.less
// module id = 1214
// module chunks = 1